import { TagIcon } from '@heroicons/react/24/solid';
import { formatDistance } from 'date-fns';
import { Link } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { isNullOrUndefined } from '../../features/new-workpaper/utils';

function TrialAction(): JSX.Element {
    const firm = useFirmContext();
    if (!firm.subscription || isNullOrUndefined(firm.subscription?.trialEnd)) return <></>;

    const trialEnd = new Date(firm.subscription.trialEnd).getTime();

    return (
        <div className="hidden items-center text-sm text-white lg:flex ml-4">
            {Date.now() >= trialEnd ? (
                <p>Trial expired</p>
            ) : (
                <p>
                    Trial ends in <b>{formatDistance(new Date(firm.subscription!.trialEnd), new Date(), { addSuffix: false })}</b>
                </p>
            )}
            <Link
                to={`/${firm.shortId}/settings?tab=billing-subscription`}
                className="border-2 border-white rounded-md flex items-center justify-center py-1 px-2 ml-2"
            >
                <TagIcon className="h-4 w-4 mr-2" /> Subscribe Now
            </Link>
        </div>
    );
}

export default TrialAction;
